import { Map, fromJS } from 'immutable';

export function request(state, { id, market }) {
    let items = state.get('items') || Map();

    id = id || market.id;

    items = items.set(
        id,
        items.get(id).set('_state', 'IN_PROGRESS')
    );

    return state.set('items', items);
}

export function error(state, { id, errors }) {
    let items = state.get('items') || Map();

    items = items.set(
        id,
        items.get(id)
            .set('_state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set('items', items);
}

export function finish(state, { id, market, response }) {
    let items = state.get('items') || Map();

    market._state = 'FINISHED';

    let terms = state.get('items').toJS()[id].eachWay.terms;

    if (market.eachWay) {
        market.eachWay.terms = response.eachWay.terms;
    }

    if (market.betLimitsMap && response.betLimitsMap) {
        for(let type in market.betLimitsMap){
            for(let betLimit in market.betLimitsMap[type]){
                market.betLimitsMap[type][betLimit] = +response.betLimitsMap[type][betLimit] / 100;
            }
        }
    }

    if (market.cashoutMarketSettings) {
        for (let value in market.cashoutMarketSettings) {
            market.cashoutMarketSettings[value] = market.cashoutMarketSettings[value] !== 0 ? +market.cashoutMarketSettings[value] / 100 : null;
        }
    }

    return state.mergeDeepIn([ 'items', id ], fromJS(market));
}

// Pure updates

export function update(state, action) {
    if (!action.data.id) {
        action.data.id = action.id;
    }

    return bulk(
        state,
        {
            data: [
                action.data
            ]
        }
    );
}

export function bulk(state, action) {
    let items = state.get('items');

    action.data.forEach((market) => {

        for(let type in market.betLimitsMap){
            for(let betLimit in market.betLimitsMap[type]){
                market.betLimitsMap[type][betLimit] = +market.betLimitsMap[type][betLimit] / 100;
            }
        }

        for (const value in market.cashoutMarketSettings) {
            market.cashoutMarketSettings[value] = market.cashoutMarketSettings[value] !== 0 ? +market.cashoutMarketSettings[value] / 100 : null;
        }

        items = items.mergeIn([ market.id ], fromJS(market));
    });

    return state.set('items', items);
}
